import { api } from './api';
import type { AutopilotConfig, AutopilotNotification, AutopilotStatus, SkipLogEntry } from '../types';

export const autopilotApi = {
  getConfig: (channelId: number) =>
    api.get<AutopilotConfig>(`/autopilot/${channelId}/config`),

  updateConfig: (channelId: number, updates: Partial<AutopilotConfig>) =>
    api.put<AutopilotConfig>(`/autopilot/${channelId}/config`, updates),

  enable: (channelId: number) =>
    api.post<AutopilotConfig>(`/autopilot/${channelId}/enable`),

  pause: (channelId: number) =>
    api.post<{ paused: true; cancelled_count: number }>(`/autopilot/${channelId}/pause`),

  resume: (channelId: number) =>
    api.post<{ paused: false }>(`/autopilot/${channelId}/resume`),

  getStatus: (channelId: number) =>
    api.get<AutopilotStatus>(`/autopilot/${channelId}/status`),

  getNotifications: (channelId: number, unreadOnly = false) =>
    api.get<AutopilotNotification[]>(
      `/autopilot/${channelId}/notifications${unreadOnly ? '?unread_only=true' : ''}`
    ),

  markAllRead: (channelId: number) =>
    api.post<{ success: true }>(`/autopilot/${channelId}/notifications/read-all`),

  markRead: (notificationId: number) =>
    api.post<{ success: true }>(`/autopilot/notifications/${notificationId}/read`),

  getSkipLog: (channelId: number) =>
    api.get<SkipLogEntry[]>(`/autopilot/${channelId}/skip-log`),

  getWarmupLog: (channelId: number) =>
    api.get<any[]>(`/autopilot/${channelId}/warmup-log`),

  getRetryLog: (channelId: number) =>
    api.get<any[]>(`/autopilot/${channelId}/retry-log`),
};
